import { render, staticRenderFns } from "./modal-registro-incidente.vue?vue&type=template&id=8b00c9e8&"
import script from "./modal-registro-incidente.vue?vue&type=script&lang=js&"
export * from "./modal-registro-incidente.vue?vue&type=script&lang=js&"
import style0 from "./modal-registro-incidente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports